import type { CampaignStatus } from './types';

export const CAMPAIGN_STATUS_LABELS: Record<CampaignStatus, string> = {
  0: 'Planned',
  1: 'Active',
  2: 'Completed',
  3: 'Cancelled',
};

export const CAMPAIGN_STATUS_OPTIONS = Object.entries(CAMPAIGN_STATUS_LABELS).map(
  ([value, label]) => ({ value: Number(value) as CampaignStatus, label })
);
